import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';
import { StorageService } from 'app/core/services/storage.service';
import { ProductService } from 'app/solar/common/services/product.service';

@Injectable()
export class UberFilterDataService {

  private cache$: Observable<any>;
  private reload$ = new Subject<void>();

  constructor(
    private requestService: RequestService,
    private configService: ConfigService,
    private storageService: StorageService,
    private productService: ProductService
  ) { }


  getData(url: string, params: string): Observable<any> {
    if (!this.cache$) {
      this.cache$ = this.requestService.get(url, params, 'json').takeUntil(this.reload$).shareReplay(1);
    }
    return this.cache$;
  }

  // getParsedData(params: any): Observable<any> {
  //   debugger;
  //   return this.getData(this.url).flatMap(it => Observable.create(observer =>
  //     observer.next(it.slice((params.page-1)*params.limit, params.page*params.limit))))
  // }
  // private requestCategories() {
  //   return this.productService.getProductGroups(1, { productType: 'Exam' }).map(body => body.data);
  // }

  refreshCategories(): any {
    // Calling next will complete the current cache instance
    this.reload$.next();

    // Setting the cache to null will create a new cache the
    // next time 'getData' is called
    this.cache$ = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/solar/common/uber-filter/uber-filter-data.service.ts